import { useTranslation } from 'react-i18next';

import { Button } from '@/components/generic';

type VideoTypeSelectorProps = {
  options: string[];
  selected: string;
  onChange: (value: string) => void;
};

export const VideoTypeSelector = ({ options, selected, onChange }: VideoTypeSelectorProps) => {
  const [t] = useTranslation('common');

  return (
    <div className='relative mt-4 flex w-full justify-between overflow-hidden rounded-[15px] bg-secondary-pale-blue-gray p-1 md:w-[95%]'>
      {options.map((option) => {
        return (
          <Button
            key={option}
            handleOnClick={() => onChange(option)}
            className={`z-10 w-1/2 py-2 transition-colors duration-200 ease-in-out ${selected !== option && 'bg-secondary-pale-blue-gray text-secondary-gray hover:text-primary-black'} `}>
            {t(option)}
          </Button>
        );
      })}
    </div>
  );
};
